module.exports = __webpack_public_path__ + "static/img/login-admin.80602b5.jpg";